import { usePostHog } from '@posthog/react';
import { useCallback } from 'react';

export function useAnalytics() {
  const posthog = usePostHog();

  const identifyUser = useCallback(
    ({ username, email, name } = {}) => {
      if (!posthog || !username) {
        return;
      }

      const normalizedUsername = username.trim().toUpperCase();
      posthog.identify(normalizedUsername, {
        username: normalizedUsername,
        ...(email ? { email } : {}),
        ...(name ? { name } : {}),
      });
      posthog.reloadFeatureFlags();
    },
    [posthog]
  );

  const track = useCallback(
    (eventName, properties) => {
      if (!posthog || !eventName) {
        return;
      }

      posthog.capture(eventName, properties);
    },
    [posthog]
  );

  return { identifyUser, track };
}
